import { css } from "@emotion/react";

import { spacing } from "@every.org/common/src/display/spacing";

import { colorCssVars } from "src/theme/color";
import { textSizeCss } from "src/theme/text";

export const adminInputStyles = css`
  ${textSizeCss.xs};
  padding: ${spacing.xs} ${spacing.l} ${spacing.xs} ${spacing.s};
  text-align: start;
  color: var(${colorCssVars.text.secondary});
  box-sizing: border-box;
  border: 0;
  background: transparent;
  width: 100%;
  caret-color: var(${colorCssVars.input.caret});
  ::placeholder {
    color: var(${colorCssVars.text.secondary});
  }
  :focus {
    outline: none;
  }
  border-radius: 8px;
  background: var(${colorCssVars.input.background.default});
  &:not(:focus-within):hover {
    background: var(${colorCssVars.input.background.hover});
  }
  &:focus-within {
    border: 1px solid var(${colorCssVars.input.border.focus});
    box-shadow: 0px 0px 0px 2px var(${colorCssVars.input.outline.focus});
    background: var(${colorCssVars.input.background.focus});
  }
  border: 1px solid var(${colorCssVars.input.background.default});
  overflow: hidden;
  white-space: nowrap;
  word-break: break-word;
  text-overflow: ellipsis;
`;

export const adminSelectStyles = css`
  ${textSizeCss.xs};
  .Dropdown-control {
    padding: ${spacing.xs} ${spacing.l} ${spacing.xs} ${spacing.s};
  }
  .Dropdown-arrow {
    top: 1.1em;
  }
`;
